/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Volver',
      changePassword: 'Cambiar contraseña',
      copiedVaultId: '¡Copiado!',
      copyVaultID: 'Copia ID Vault',
      create: 'Crear',
      next: 'Siguiente',
      notSure: 'No estoy seguro/a.',
      signUp: 'Registrarse',
      submit: 'Enviar',
      updatePassword: 'Actualizar contraseña',
    },
    Errors: {
      createReportFailed: 'Error en la creación del informe.',
    },
    ReportStatus: {
      CLOSED: 'Cerrado',
      INVESTIGATING: 'Investigación en curso',
      NEW: 'Enviado',
      READ: 'Leído',
    },
    general: {
      navbar: {
        caseSettings: 'Ajustes del caso',
        changePassword: 'Cambiar contraseña',
        logOut: 'Cerrar sesión',
        notifications: 'Notificaciones',
        notificationsDrawer: {
          appFileScanFailed:
            'Un archivo ha fallado la verificación de seguridad',
          appReportMatch: 'Tu registro GoTogether ha sido emparejado',
          appReportReassigned: 'Se ha asignado un nuevo gestor de casos',
          case: 'Caso',
          caseAssigned: 'Caso asignado a ti',
          caseImporterJobCompleted: {
            PartialSuccess: 'La importación de su caso se completó con errores',
            failure: 'La importación de tu caso falló',
            success: 'Tu importación de casos se completó con éxito',
          },
          caseLinked: 'Caso vinculado',
          caseTeamInvite: 'Añadido al caso',
          caseUnlinked: 'Caso desvinculado',
          dataSanitisation: 'Detalles del informe actualizados',
          emptyDescription: 'Vuelve más tarde para ver nuevas notificaciones',
          emptyTitle: 'Estás completamente al día',
          importId: 'ID de importación:',
          learnMore: 'Aprende más',
          markAllAsRead: 'Marcar todo como leído',
          newMessage: 'Nuevo mensaje',
          newReport: 'Nuevo informe recibido',
          permissionRemoved: 'Eliminado del caso',
          postSSubmissionFile: 'Archivo(s) de evidencia añadido(s)',
          report: 'Informe',
          reportAssigned: 'Informe asignado a usted',
          reportStatusChange: 'Estado del informe cambiado',
          reporterAnonymised: 'Tus detalles han sido anonimizados',
          reporterReportSubmitted: {
            subtitle: 'Recomendamos guardar una copia de tu informe',
            title: 'Informe presentado',
          },
          mitigationPlanReminder:
            'Se requiere aprobación del plan de mitigación',
          staleCase: 'Caso sin acción',
        },
        privacyStatement: 'Declaración de privacidad',
        reporter: {
          myReports: 'Mis informes',
        },
        settings: 'Ajustes',
        technicalSupport: 'Soporte técnico',
        title: 'Cuenta',
      },
      time: {
        day: 'Día',
        days: 'Días',
        hour: 'Hora',
        hours: 'Horas',
        minute: 'Minuto',
        minutes: 'Minutos',
        second: 'Segundo',
        seconds: 'Segundos',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anónimo',
        autoTranslate: 'La traducción automática está desactivada por defecto.',
        backToMessages: 'Volver a los mensajes',
        caseSettings: 'Configuración del caso.',
        changeInProfile:
          'Si deseas cambiar esta configuración, puedes hacerlo en tu perfil',
        deletedByMessage: 'Eliminado por {{author}}',
        deletedMessageLabel: 'Este mensaje fue eliminado',
        description:
          'Cuando la traducción automática está activada, todos los mensajes del informe se traducirán automáticamente utilizando IA basada en el idioma predeterminado seleccionado en su navegador.',
        descriptionSecondHalf:
          'La versión original de todos los mensajes siempre se conserva y se puede encontrar en el chat.',
        messagePlaceholder: 'Comienza a escribir...',
        messageSettings: 'Configuraciones de mensajes.',
        originalMessages: 'Original',
        showMoreBanner: 'Aprende más sobre las traducciones automáticas',
        titlev2: 'Lee todos los mensajes en tu idioma preferido.',
        translatedMessageLabel: 'Mensaje Traducido',
        translatedMessages: 'Traducido',
        understood: 'Entendido',
      },
      Country: {
        description: '¿En qué país está usted ubicado?',
        header: '¿En qué país está usted ubicado?',
        noOptions: 'No se encontraron países',
        other: 'Otro',
        placeholder: 'Buscar un país...',
      },
      CreatePublicReport: {
        createReport: 'Crear un nuevo informe',
        helpPage: 'Ve a nuestra página de ayuda',
        loginToOpr: 'Iniciar sesión para rastrear informes',
        or: 'o',
        passwordPlaceholder: 'Introduzca su contraseña',
        phoneNumberLoginFailed:
          'Inicio de sesión fallido, número de teléfono/pin incorrecto',
        phoneNumberPlaceholder: 'Introduce tu número de teléfono',
        phoneNumberTooltip:
          'Introduce el número de teléfono que usaste para contactar a VaultTalk',
        pinPlaceholder: 'Introducir PIN',
        reportIntroductionParagraph1:
          'Cuando informes de un incidente, se te harán algunas preguntas para ayudarte a documentar tu experiencia.',
        reportIntroductionParagraph2:
          'Antes de enviar, tienes la opción de permanecer anónimo para proteger tu privacidad.',
        reportIntroductionParagraph3:
          'Después de enviar, puedes iniciar sesión en cualquier momento para ver el progreso de tu informe y hablar con un gestor de casos.',
        reportIssue: 'Informar de una incidencia',
        usernameLoginFailed:
          'Inicio de sesión fallido, nombre de usuario/contraseña incorrecto',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Se requiere relación con la empresa',
            reportedCategoryRequired: 'Se requiere la categoría reportada',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Introduce tu correo electrónico o ID de Vault',
        vaultIdTooltip:
          'Para informes anónimos, el ID de Vault es alfanumérico. Si el informe no fue anónimo, el ID de Vault es tu dirección de correo electrónico.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Tu Contraseña',
        yourPhoneNumber: 'Tu número de teléfono',
        yourPin: 'Tu Pin de 6 Dígitos',
        yourVaultId: 'Tu ID de Vault',
      },
      CustomHeader: {
        companyLogo: 'Logotipo de la empresa',
        openReporting: 'Información pública',
        userSettings: 'Ajustes del usuario',
      },
      Date: {
        approximateDescription: '¿Recuerda la fecha aproximada del evento?',
        approximatePlaceholder:
          'Ejemplo: hace 6 meses / el año pasado / el pasado mes de noviembre',
        cancel: 'cancelar',
        clear: 'borrar',
        description: '¿Recuerda la fecha en que tuvo lugar el evento?',
        header: '¿Qué día tuvo lugar?',
        ok: 'aceptar',
        placeholder: 'Ejemplo: 21 de junio de 2020',
      },
      Description: {
        whatHappened: '¿Que sucedió?',
        whatHappenedPlaceholder: 'Use sus propias palabras...',
        whatHappenedText: 'En sus propias palabras, describa lo sucedido',
      },
      Details: {
        disclaimer:
          'Estos detalles serán revelados con su informe. Si desea permanecer anónimo, asegúrese de que no contengan información de identificación.',
        emailPlaceholder: 'Correo electrónico (opcional)',
        fullNamePlaceholder: 'Nombre completo (opcional)',
        header: 'Sus datos',
        nonAnonSubtitle:
          'Por favor, proporciona tu nombre o una dirección de correo electrónico. Si deseas recibir notificaciones sobre este informe, agrega una dirección de correo electrónico adecuada a continuación.',
        nonOptionalEmailPlaceholder: 'Correo electrónico',
        nonOptionalFullNamePlaceholder: 'Nombre completo',
        subtitle:
          'Si quieres recibir notificaciones sobre este informe, añade una dirección de correo electrónico apropiada a continuación.',
      },
      Emotion: {
        description: '¿Qué pensó al respecto? ¿Cuál fue el impacto?',
        header: '¿Cuál fue el impacto?',
        placeholder: 'Comience a escribir...',
      },
      Evidence: {
        addedHeading: 'Añadido',
        deletedMessage: 'fue eliminado',
        deletedStatus: 'Eliminado',
        failedToOpenFileMessage:
          'Error al abrir el archivo. Por favor, inténtalo de nuevo.',
        fileStatuses: {
          infectedUpload: 'Marcado por control de seguridad',
          passedUpload: 'Pasó la verificación de seguridad',
          pendingUpload: 'Verificación de seguridad en progreso',
          readyForDownload: 'Listo para descargar',
        },
        mobileErrorMessage:
          'Archivos marcados: mensajea a tu administrador de casos',
        nameHeading: 'Nombre',
        statusHeading: 'Estado',
        tableTitle: 'Evidencia',
        webErrorMessage:
          'Archivos marcados: Si tu(s) archivo(s) ha sido marcado, por favor envía un mensaje al gestor del caso.',
      },
      FileUpload: {
        addFiles: 'Añadir archivos',
        addMoreFiles: 'Añadir más archivos',
        confirm: 'Confirmar',
        description:
          'Agregar archivos como evidencia puede ayudar a respaldar la eficiencia de la resolución por parte de su gestor de casos. Por favor, tenga en cuenta el contenido del archivo (incluyendo los metadatos del archivo) si desea permanecer anónimo, y respete los derechos de otras personas y las leyes aplicables.',
        dragDrop: 'Deja los archivos aquí o',
        errorMessage:
          'El archivo(s) falló debido a un error de red. Haz clic abajo para enviar un mensaje a tu administrador de casos para obtener asistencia.',
        fileLimit: 'Límite de tamaño para cada archivo: 100MB',
        fileUploadLimitText: 'Solo puedes subir 10 archivos',
        header: 'Añadir evidencia',
        helpArticle: 'artículo de ayuda',
        highlighted: 'explorar archivos',
        information: 'Tipos de archivos admitidos',
        moreInformation:
          'Para más información, por favor vea esto <a>artículo de ayuda</a>',
        postSubmissionErrorMessage:
          "No pudimos subir tus archivos debido a un error del sistema. Por favor, selecciona 'confirmar' de nuevo.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documentos:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Imágenes:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Texto:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Vídeo:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'El archivo es demasiado grande',
          invalidFileType: 'Tipo de archivo no soportado: {{extension}}',
          systemError: 'Error del sistema',
          tooManyFiles: 'El número máximo de archivos es {{maxFiles}}',
        },
        uploadFiles: 'Subir archivos',
      },
      Loading: {
        loading:
          'Por favor espera mientras enviamos tu informe a un administrador de casos...',
        postSubmissionLoading:
          'Por favor espera mientras enviamos tu(s) archivo(s)...',
      },
      Location: {
        description: '¿Dónde sucedió?',
        header: '¿Dónde sucedió?',
        placeholder: 'Ejemplo: en la oficina',
      },
      MessageListBox: {
        messageCaseManager: 'Enviar un mensaje al encargado del caso',
        report: 'Informe {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Traducción desactivada',
        enableTranslationLabelEnabled: 'Traducción habilitada',
        enableTranslationsDescription:
          'Habilite las traducciones automáticas y lea todos los mensajes de informe en su idioma preferido. El idioma traducido se basa en el idioma seleccionado en su dispositivo.',
        enableTranslationsHeader:
          'Habilitar auto-traducciones para mensajes de informe',
        enableTranslationsSubDescriptionv2:
          'Puedes alternar entre el idioma traducido y el original en cada chat.',
        updateTranslationFailed: 'La actualización de la traducción ha fallado',
        updateTranslationSuccess:
          'La configuración de traducción se ha actualizado correctamente',
      },
      Password: {
        changePasswordHeader: 'Cambiar contraseña',
        createNewPassword: 'Por favor, cree una nueva contraseña',
        createPasswordHeader: 'Su contraseña',
        currentPasswordPlaceholder: 'Introducir la contraseña actual',
        description:
          'Una contraseña válida debe tener al menos nueve caracteres e incluir una letra mayúscula y un número',
        enterCurrentPassword: 'Introduzca su contraseña actual.',
        forgottenPasswordInstructions:
          'Ingrese su ID alfanumérico de Vault (no su dirección de correo electrónico) y dirección de correo electrónico para restablecer su contraseña.',
        newDescription:
          'Crea una contraseña fuerte para mantener tu cuenta segura. Comienza a escribir para ver las pautas a continuación.',
        passwordPlaceholder: 'Cree una contraseña.',
        passwordResetRequestedDescription:
          'Si tu ID de Vault existe en nuestro sistema, recibirás un correo electrónico con instrucciones para restablecer tu contraseña.',
        passwordResetRequestedHeader:
          'Se ha solicitado el enlace para restablecer la contraseña',
        reenterPlaceholder: 'Introduzca la contraseña de nuevo.',
        subtitle:
          'Crear una contraseña para enviar este informe y para acceder a él en un futuro',
        yourVaultId: 'Tu ID de Vault',
        yourVaultIdPlaceholder:
          'Ingrese su ID de Vault (por ejemplo, {{exampleId}})',
      },
      Perpetrators: {
        description:
          '¿El informe se refiere a una única persona o a varias personas? ¿Podría indicarnos sus nombres o aspectos de ellos?',
        header: 'Personas involucradas',
        placeholder:
          'Comience a escribir y utilice la coma (,) para separar los diferentes nombres y aspectos de la descripción',
      },
      PoweredByVault: 'Desarrollado por {{company}}',
      PrivacyStatement: 'Declaración de Privacidad del Producto',
      PublicMessageList: {
        myMessages: 'Mis mensajes',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Evidencia añadida al informe existente',
        backToReportId: 'Volver al informe ID: {{reportId}}',
        description:
          'Agregar archivos como evidencia puede ayudar a respaldar la eficiencia de la resolución por parte de su administrador de casos. Por favor, considere el contenido del archivo (incluyendo los metadatos del archivo) si desea permanecer anónimo, y respete los derechos de otras personas y las leyes aplicables. Para obtener más información, por favor, consulte esto. <a>artículo de ayuda</a>',
        header: 'Agrega evidencia adicional al informe',
        vaultTalkOpenCaseHeader: 'Añade evidencia a tu informe',
      },
      PublicReport: {
        anonymous: 'Anónimo',
        backToReports: 'Volver a informes',
        skipped: 'Omitido',
      },
      PublicReportCard: {
        addEvidence: 'Añade evidencia adicional',
        messageCaseManager: 'Enviar un mensaje al encargado del caso',
        reportId: 'ID de informe:',
        submitted: 'Enviado',
        vaultTalkClosedCaseCTA: 'Ver Evidencia',
        vaultTalkOpenCaseCTA: 'Añadir Evidencia',
        viewAdditionalEvidence: 'Ver evidencia adicional',
        viewReport: 'Ver informe',
      },
      PublicReportsList: {
        reportingSystem: 'Sistema de notificación de informes',
      },
      Question: {
        placeholder: 'Comienza a escribir...',
        question: 'Proporcionar detalles',
        questionText:
          'Por favor, comparte con nosotros tu preocupación, actualización o consulta.',
      },
      Relationship: {
        header: 'Relación que tiene con la organización/empresa',
        tellUsAbout:
          'Por favor, indíquenos qué relación tiene con la organización/empresa.',
      },
      ResponsiveNavMenu: {
        messages: 'Mis mensajes',
        reports: 'Mis informes',
      },
      Site: {
        description: '¿En qué centro está usted ubicado?',
        header: '¿En qué centro está usted ubicado?',
        noOptions: 'No se encontraron centros',
        other: 'Otro',
        placeholder: 'Buscar un centro...',
      },
      SpamPuzzle: {
        dialog: 'Para continuar, debe resolver el rompecabezas',
      },
      SubmissionTypes: {
        reportIssue: 'Seleccione una categoría',
        whatType: 'Seleccione la categoría que mejor describa su informe',
      },
      SubmitSuccess: {
        category: '<bold>Categoría:</bold> {{category}}',
        country: '<bold>País:</bold> {{country}}',
        dateSubmitted: '<bold>Fecha de envío:</bold> {{date}}',
        recordYourVaultID: 'Recuerda esta información para iniciar sesión',
        successInformation: 'Más información',
        successMessage:
          'Tu informe ha sido enviado y está listo para su revisión. Cualquier archivo adjunto que requiera atención será marcado al iniciar sesión. Inicia sesión a continuación para ver las actualizaciones del informe y enviar mensajes a tu gestor de casos.',
        successSanitationMessage:
          'Guarda una copia para tus registros y mantén tu Vault-ID a salvo, lo necesitarás para acceder a las actualizaciones y enviar mensajes a tu gestor de casos.',
        successSanitationTagline:
          'Tu informe fue enviado y almacenado de forma segura.',
        successThankYou: '¡Gracias por su informe!',
        viewReport: 'Ver informe',
      },
      Time: {
        approximateDescription:
          '¿Recuerda la hora aproximada a la que sucedió el evento?',
        approximatePlaceholder: 'Ejemplo: por la mañana, por la tarde',
        description: '¿Recuerda la hora en que tuvo lugar el evento?',
        header: '¿A qué hora sucedió?',
        invalidTime: 'El formato de hora tiene que ser HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Cambiar contraseña',
        closeDialog: 'Cerrar cuadro de diálogo',
        logout: 'Cerrar sesión',
        messageSettings: 'Configuración de mensajes',
        userSettings: 'Ajustes del usuario',
      },
      Witnesses: {
        description:
          '¿Se lo comentó a otra persona o alguien más vio lo sucedido?',
        header: '¿Algún testigo?',
        placeholder: 'Comience a escribir...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Enviar mensaje',
        title: 'Mensaje para el Gestor de Casos',
        translationHeader: 'Aprende más sobre las traducciones automáticas',
      },
      ReportCard: {
        addEvidence: 'Añadir evidencia',
        submissionModeVia: 'a través de {{submissionMode}}',
        viewEvidence: 'Ver evidencia',
      },
      ReportList: {
        yourReports: 'Tus Informes',
      },
      ReportingActivate: {
        buttonText: 'Continuar',
        description:
          'Si tu organización te ha registrado para una cuenta, te enviaremos un correo electrónico con instrucciones para completar la configuración.',
        emailInput: 'Correo electrónico',
        header: 'Ingrese su correo electrónico de trabajo',
        successAccount:
          'Si su organización lo ha registrado para una cuenta, le enviaremos un correo electrónico con instrucciones para completar la configuración.',
        successEmail:
          'Si no lo ves inmediatamente, por favor espera unos minutos y actualiza tu bandeja de entrada de correo electrónico.',
        successHeading: 'Gracias',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Añade evidencia a tu informe',
        descriptionText:
          'Agregar archivos como evidencia puede ayudar a mejorar la eficacia de la resolución por parte de su administrador de casos. Por favor, considere el contenido del archivo (incluyendo metadatos del archivo) si desea permanecer anónimo, y respete los derechos de los demás individuos y las leyes aplicables. Para más información, por favor vea este <a>artículo de ayuda</a>',
        emptyMessage: 'No se ha subido ninguna evidencia adicional',
      },
      ReportingChangePassword: {
        back: 'Atrás',
        description:
          'Crea una contraseña fuerte para mantener tu cuenta segura. Empieza a escribir para ver las directrices a continuación.',
        errorToast: 'No se puede crear la contraseña, token no válido.',
        header: 'Cambiar Contraseña',
        incorrectCurrentPassword:
          'La contraseña actual es incorrecta. Por favor, compruébala e inténtalo de nuevo.',
        invalidToken: 'Token inválido',
        passwordUpdated: 'Contraseña actualizada',
        passwordUpdatedDescription:
          'Tu contraseña ha sido actualizada con éxito. ¡Gracias por dar este paso para mantener tus datos seguros!',
        passwordUsedBefore: 'No se permite reutilizar la contraseña',
        passwordUsedBeforeDescription:
          'Por su seguridad, no puede reutilizar ninguna de sus últimas seis contraseñas. Por favor, elija una nueva contraseña única para mantener su cuenta segura e inténtelo de nuevo.',
        toastDescription:
          'Tu contraseña ha sido actualizada con éxito. ¡Gracias por dar este paso para mantener seguros tus datos!',
        toastMessage: 'Contraseña actualizada',
        updatePasswordCTA: 'Actualizar contraseña',
      },
      ReportingConnect: {
        cancelButton: 'Cancelar',
        connectButton: 'Conectar',
        disclaimer:
          'Conectar tu cuenta de Slack con tu cuenta de Vault asegura una conexión segura y privada.<br /><br />Al conectar, puedes reportar conductas indebidas o hacer una pregunta directamente dentro de Slack. Siempre tendrás la opción de reportar de forma anónima después de conectar. Tu privacidad y tu seguridad son nuestras principales prioridades.',
        heading:
          'Vault Platform está solicitando permiso para acceder a tu cuenta de Slack de {{organisationName}}',
        listHeading: '¿Qué podrá hacer Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault tendrá la capacidad de ver la identidad de tu usuario de Slack',
          heading: 'Ver información sobre la identidad de un usuario',
        },
        permissionNotifications: {
          extraInfo:
            'Vault podrá enviarte notificaciones a tu cuenta de Slack, respecto a cualquier actualización de un informe enviado o pregunta.',
          heading: 'Enviarle notificaciones',
        },
        permissionOverview: {
          extraInfo:
            'Vault mostrará un resumen de todas las presentaciones en la página principal.',
          heading: 'Resumen de las presentaciones',
        },
        permissionSubmitReport: {
          extraInfo:
            'Esto concederá a Vault el permiso para enviar un informe o hacer una pregunta directamente a tu organización, desde Slack.',
          heading: 'Enviar un informe o pregunta en su nombre',
        },
        successfulConnectionDescription:
          'Tu cuenta de Vault y tu cuenta de Slack ahora están conectadas. Ahora puedes cerrar esta pestaña y volver a Slack.',
        successfulConnectionHeading: 'Conexión exitosa',
        unsuccessfulConnectionDescription:
          'Algo salió mal. Por favor, cierra esta pestaña y vuelve a Slack para intentarlo de nuevo.',
        unsuccessfulConnectionHeading: 'Fallo en la conexión',
      },
      ReportingForgotPassword: {
        description:
          'Introduce la dirección de correo electrónico asociada con tu cuenta, y te enviaremos un enlace para restablecer tu contraseña.',
        heading: 'Contraseña olvidada',
        invalidTokenError: 'No se puede crear la contraseña, token inválido.',
        passwordReuseError: 'No se permite la reutilización de contraseñas',
        passwordReuseErrorDescription:
          'Por tu seguridad, no puedes reutilizar ninguna de tus últimas seis contraseñas. Por favor, elige una nueva contraseña única para mantener tu cuenta segura y prueba de nuevo.',
        sendLink: 'Enviar enlace de restablecimiento',
        sendLinkFailure: 'Algo salió mal',
        sendLinkFailureDescription:
          'Regresa al <a>Centro de Reportes</a> e intenta de nuevo. Si el problema persiste, ponte en contacto con nosotros en <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Enlace de restablecimiento de contraseña enviado',
        sendLinkSuccessDescription:
          'Hemos enviado un enlace para restablecer la contraseña a {{email}}',
        updatePasswordSuccess: 'Contraseña actualizada',
        updatePasswordSuccessDescription:
          'Tu contraseña ha sido actualizada con éxito. ¡Gracias por dar este paso para mantener tus datos seguros!',
      },
      ReportingLogin: {
        accountFrozen: 'La cuenta está congelada',
        accountLocked:
          'Se ha intentado iniciar sesión demasiadas veces de manera incorrecta. La cuenta está bloqueada hasta por 1 hora. No es posible restablecer la contraseña durante este tiempo.',
        accountLockedPermanently:
          'Su cuenta ha sido bloqueada. Use la opción de restablecer contraseña para recuperar el acceso o contacte a su administrador de sistema para obtener más ayuda.',
        createAccountCTA: 'Regístrate para obtener una cuenta',
        currentPassword: 'Contraseña Actual',
        emailLabel: 'Tu correo electrónico',
        forgotPassword: '¿Olvidaste tu contraseña?',
        loginButton: 'Iniciar sesión',
        newPasswordPlaceholder: 'Nueva contraseña',
        passwordFailMessage:
          'Regresa a la aplicación Vault en Slack e inténtalo de nuevo. Si el problema continúa, contáctanos en techsupport@vaultplatform.com',
        passwordFailTitle: 'Algo salió mal',
        passwordLabel: 'Tu Contraseña',
        passwordPlaceholder: 'Ingresa tu contraseña',
        passwordResetRequired: 'Se requiere restablecer la contraseña',
        passwordSuccessfullySetMessage:
          'Regresa a la aplicación Vault en Slack y autentícate con tu nueva contraseña para continuar donde lo dejaste.',
        passwordSuccessfullySetTitle: 'Contraseña establecida con éxito',
        reenterPlaceholder: 'Vuelve a introducir la contraseña',
        title: 'Hub de Reportero',
        tooltip:
          'Si nunca has establecido una contraseña para la aplicación Vault aún, sigue aquí para comenzar. Si has olvidado tu contraseña, usa el enlace "Olvidé mi contraseña" que está abajo.',
        usernameLoginFailed:
          'Error de inicio de sesión, nombre de usuario o contraseña incorrectos',
      },
      ReportingReset: {
        failureDescription:
          'Regresa a la aplicación Vault en Slack e inténtalo de nuevo. Si el problema persiste, contáctanos en <mailto> techsupport@vaultplatform.com </mailto>',
        failureHeading: 'Algo salió mal',
        successDescription:
          'Regresa a la aplicación Vault en Slack y autentícate con tu nueva contraseña para continuar donde lo dejaste.',
        successHeading: 'Contraseña establecida con éxito',
      },
      noReports: {
        description:
          'Todos los informes enviados se mostrarán aquí. Aprende más sobre las formas en que puedes enviar un informe en',
        descriptionHelpArticle: 'este artículo de ayuda',
        errorDescription:
          'Estamos teniendo problemas para cargar tus informes. Por favor, intenta actualizar la página.',
        errorDescriptionSecondary:
          'Si eso no funciona, por favor póngase en contacto con nosotros en',
        errorTitle: '⚠️ Vaya, algo ha salido mal.',
        title: 'Todavía no tienes informes',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Habilita las traducciones automáticas y lee todos los mensajes de informe en tu idioma preferido. El idioma traducido se basa en el idioma seleccionado en tu dispositivo.',
          autoTranslationDescription2:
            'Puedes cambiar entre el idioma traducido y el original en cada chat.',
          autoTranslationTitle:
            'Habilitar auto-traducciones para mensajes de reporte',
          header: 'Configuración de mensajes',
          subHeader: 'Configura cómo se muestran los mensajes',
        },
        notificationSettings: {
          emailDescription:
            'Recibe notificaciones por correo electrónico para actualizaciones importantes en tus informes',
          emailTitle: 'Notificaciones por Correo Electrónico',
          header: 'Configuración de Notificaciones',
          subHeader: 'Configura cómo recibes las notificaciones',
        },
        title: 'Ajustes',
        updatedSettingsFailure: 'Error al actualizar tus configuraciones',
        updatedSettingsSuccess: 'Se han actualizado tus ajustes con éxito',
      },
    },
    validators: {
      passwordLength: 'La contraseña debe tener al menos nueve caracteres.',
      passwordLowercase:
        'La contraseña debe contener al menos una letra minúscula.',
      passwordMissMatch:
        'La contraseña y los campos de confirmación deben coincidir.',
      passwordNumeric: 'La contraseña debe contener al menos un número.',
      passwordUppercase:
        'La contraseña debe contener al menos una letra mayúscula.',
    },
    validatorsNew: {
      passwordLength: 'Entre 10 y 30 caracteres',
      passwordLowercase: 'Al menos una letra minúscula',
      passwordMissMatch: 'Las contraseñas no coinciden',
      passwordNumeric: 'Al menos un número',
      passwordSpecialCharacter: 'Al menos un carácter especial',
      passwordUppercase: 'Al menos una letra mayúscula',
    },
  },
};

export default translations;
